import React from "react";
import PropTypes from "prop-types";
import s from "./start-page.module.scss";

import translate from "../../translations";

export default class StartPage extends React.Component {
  constructor(props) {
    super();
    this.tool = props.tool;
    this.state = {};
    this.start = this.start.bind(this);
  }

  start() {
    this.props.onStart();
  }

  componentDidMount() {
    // NB: gets called twice in development due to strict mode, see:
    // https://legacy.reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects
    if (window.parent) {
      window.parent.postMessage(
        {
          ga4_event: "page_view",
          eventData: {
            page_location: "#start",
          },
        },
        "*"
      );
    }
  }

  render() {
    return (
      <div className={s.startPageContainer}>
        <div
          className="text-primary"
          dangerouslySetInnerHTML={{ __html: this.tool.summary }}
        ></div>
        <div
          className="py-3 mb-4"
          dangerouslySetInnerHTML={{ __html: this.tool.description }}
        ></div>
        <div>
          <button onClick={this.start} className="btn btn-outline-primary">
            {translate("StartSelfAssessmentButton")}
          </button>
        </div>
      </div>
    );
  }
}

StartPage.propTypes = {
  onStart: PropTypes.func,
  tool: PropTypes.object,
};
